@import '../../styles/variables.scss';

.badge {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.375rem;
  color: $body-color;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  border-radius: $border-radius;
  background-color: $warning;
  cursor: default;
}
